import { FlaskConical, ShieldCheck, Award, Vegan, Star } from "lucide-react";

const items = [
  { icon: FlaskConical, label: "Formulado con Ker Clinic" },
  { icon: ShieldCheck, label: "COFEPRIS Registrado" },
  { icon: Award, label: ">30% β-Glucanos Certificado" },
  { icon: Vegan, label: "100% Vegano" },
  { icon: Star, label: "4.8/5 (500+ reseñas)" },
];

const TrustBar = () => {
  return (
    <section className="bg-primary text-primary-foreground py-4 overflow-x-auto">
      <div className="container flex items-center justify-around gap-6 min-w-max sm:min-w-0">
        {items.map(({ icon: Icon, label }) => (
          <div key={label} className="flex items-center gap-2 text-sm font-medium tracking-wide whitespace-nowrap">
            <Icon className="w-4 h-4 shrink-0" />
            <span>{label}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrustBar;
